import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import ConsultaTipoBMSI from '../../../../lib/json/consultas/TipoBMSI.json'

import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../components/SubmitForm";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import SelectContaContabil from "../../../components/Select/ContaContabil";
import SelectDinamico from "../../../components/SelectDinamico";

function FichaTipoBMSI(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');
    
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

    const { idTipoBMSI, empresaFilialBMSI } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialBMSI);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialBMSI);

    // Consulta do grid
    var consultaDefault  = ConsultaTipoBMSI.consulta + (idTipoBMSI ? ` AND PZ1_ID = '${idTipoBMSI}'` : '');
    const cConsulta  = "SELECT MIN(CTT_CUSTO) CTT_CUSTO, CTT_DESC01 FROM TABELA(CTT) WHERE CTT_CLASSE = '2' AND CTT_BLOQ = '2' AND CTT_TPLOT = '01' AND D_E_L_E_T_ <> '*' GROUP BY CTT_DESC01"
    const cTabelas  = "CTT"

    const [campoCodigo, setCampoCodigo]       = useState('0');
    const [campoDescricao, setCampoDescricao] = useState('');
    const [campoDepartamento, setCampoDepartamento] = useState({value: '', label: 'Selecione o Departamento'});
    const [campoCTCC, setCampoCTCC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTDC, setCampoCTDC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTCO, setCampoCTCO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTDO, setCampoCTDO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    
    useEffect(() => {
        if (idTipoBMSI){
            loadTipoBMSI();
        }
    }, []);

    // Processa consulta do grid
    const loadTipoBMSI = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaTipoBMSI.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
        
        if (retConsulta.data){
            setCampoCodigo(retConsulta.data[0].PZ1_ID);
            setCampoDescricao(retConsulta.data[0].PZ1_DESCRI);
            setCampoDepartamento({value: retConsulta.data[0].PZ1_CONTAB.trim(), label: ''});
            setCampoCTCC({value: retConsulta.data[0].PZ1_CCCRED.trim(), label: ''});
            setCampoCTDC({value: retConsulta.data[0].PZ1_CCDEBI.trim(), label: ''});
            setCampoCTCO({value: retConsulta.data[0].PZ1_CCCDIC.trim(), label: ''});
            setCampoCTDO({value: retConsulta.data[0].PZ1_CCDBIC.trim(), label: ''});            
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoDescricao) {
            toast.warning('O prenchimento do campo é obrigatório.');
            return;
        }

        const cJSON = { 
            ACAO: idTipoBMSI ? 'ALTERAR' : 'INCLUIR',
            PZ1_ID: campoCodigo,
            PZ1_DESCRI: campoDescricao,
            PZ1_CONTAB: campoDepartamento.value,
            PZ1_CCCRED: campoCTCC.value,
            PZ1_CCDEBI: campoCTDC.value,
            PZ1_CCCDIC: campoCTCO.value,
            PZ1_CCDBIC: campoCTDO.value,
        }

        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('TIPOBMSI', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false;
        }
        
        return true;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Tipo de BMSI" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Código"
                                tipo='text'
                                value={campoCodigo}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoCodigo(e.target.value)}
                                disabled={!idTipoBMSI || disabledForm }                    
                            />
                        </Col>

                        <Col md="6" xs="12">
                            <InputGeral 
                                label="Descrição"
                                tipo='text'
                                value={campoDescricao}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoDescricao(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>

                        <Col md="4" xs="12">
                            <SelectDinamico
                                campoValue={campoDepartamento}
                                showNoFilter={false}
                                onchange={(e) => setCampoDepartamento(e)}
                                EmpresaLogada={empresaFilial}
                                cText={"CTT_DESC01"}
                                cValue={"CTT_CUSTO.trim()"}
                                consulta={cConsulta}
                                tabela={cTabelas}
                                label={"Departamento Origem"}
                                disabled={disabledForm}
                            />
                        </Col>                        
                    </Row>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Conta Contábil - OverHead: </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <SelectContaContabil
                                valueTrim={true} 
                                empresaLogada={empresaFilial}
                                label="Crédito"
                                campoContaContabil={campoCTCC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTCC}                                
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectContaContabil
                                valueTrim={true} 
                                empresaLogada={empresaFilial}
                                label="Débito"
                                campoContaContabil={campoCTDC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTDC}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>                    
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Conta Contábil - Operacional: </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <SelectContaContabil
                                valueTrim={true} 
                                empresaLogada={empresaFilial}
                                label="Crédito"
                                campoContaContabil={campoCTCO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTCO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectContaContabil
                                valueTrim={true} 
                                empresaLogada={empresaFilial}
                                label="Débito"
                                campoContaContabil={campoCTDO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTDO}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>                    
                </>
            }
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : "handleCancelar"}
                onVoltar={ disabledForm ? "handleVoltar" : null}
            />
        </>
    );
}

export default FichaTipoBMSI;